import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from 'src/app/modules/_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';

@Component({
  selector: 'app-login-redirect',
  template: '',
  styleUrls: ['./login-redirect.component.scss'],
})
export class LoginRedirectComponent implements OnInit {
  token: string;
  link: string;
  sessao_app: string = '';
  tipoAcesso: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private fidelidadeService: FidelidadeService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.token.includes('?utm_source=marketingcloud'))
        this.token = params.token.split('?utm_source=marketingcloud')[0];
      else
        this.token = params.token;

      this.tipoAcesso = params.tipo?.toLowerCase();

      this.login();

      if (params.app) {
        if (params.app == 1) {
          this.sessao_app = params.app;
          this.fidelidadeService.LocalStorage.salvarSessaoApp(
            'sessao_app',
            Number(this.sessao_app)
          );
        }
      }

      if (params.link) {
        this.link = params.link;
      }
    });

  }

  private login() {
    if (!this.token) {
      this.processarFalha();
    }

    this.fidelidadeService.obterMembroPorToken(this.token).subscribe(
      (sucesso) => {
        if (this.validarStatus("email", sucesso.emailValidado)) {
          sucesso.emailValidado = true;

          this.fidelidadeService.atualizarMembroSemToken(sucesso, 'atualizacao-site:email-validado', this.token)
            .subscribe(
              (_) => this.processar(sucesso),
              (_) => this.processar(sucesso)
            );
        } else if (this.validarStatus("sms", sucesso.telefoneValidado)) {
          sucesso.telefoneValidado = true;

          this.fidelidadeService.atualizarMembroSemToken(sucesso, 'atualizacao-site:sms-validado', this.token)
            .subscribe(
              (_) => this.processar(sucesso),
              (_) => this.processar(sucesso)
            );
        }
        else {
          this.processar(sucesso);
        }
      },
      (_) => {
        this.processarFalha()
      }
    )
  }

  private validarStatus(tipo: string, estaValidado: boolean): boolean {
    return tipo === this.tipoAcesso && !estaValidado;
  }

  private processar(sucesso: any) {
    if (sucesso.tipoStatus !== 7 && sucesso.tipoStatus !== 11)
      this.authService.loginComToken(this.token).subscribe(
        (sucesso) => {
          this.processarSucesso(sucesso);
        },
        (falha) => {
          this.processarFalha();
        }
      );
    else {
      this.router.navigate([`/home?token=${this.token}`], { queryParams: { tipoStatus: this.token } });
    }
  }

  processarSucesso(response: any) {
    this.authService.LocalStorage.salvarDadosLocaisUsuario(response);
    this.fidelidadeService.obterMembro().subscribe(
      (sucesso) => {
        this.authService.LocalStorage.salvarMembro(sucesso);
        if (this.link)
          this.router.navigate(['/' + this.link]);
        else
          this.router.navigate(['/index']);
      },
      (falha) => {
        this.processarFalha();
      }
    );
  }

  processarFalha() {
    this.router.navigate(['/']);
  }
}
